import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Entry } from 'contentful';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css'],
  standalone: false
})

export class ProductListComponent implements OnInit {

  products: Entry<any>[] = [];

  constructor(
    private readonly contentfulService: ContentfulService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.contentfulService.getProducts()
    .then(products => {
      this.products = products;
      this.cdr.detectChanges();
    })
  }

}
